import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useCart } from '../context/CartContext';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/gallery', label: 'Shop' },
  { to: '/archive', label: 'Archive' },
  { to: '/about', label: 'About' },
];

const FOOTER_LINKS = [
  { to: '/about', label: 'About' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/admin/login', label: 'Admin' },
];

function CartSuccess() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const { clearCart } = useCart();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      checkStatus();
    } else {
      clearCart();
      setStatus('success');
    }
  }, [sessionId]);

  const checkStatus = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/cart/checkout/status/${sessionId}`);
      if (response.data.status === 'paid') {
        clearCart();
      }
      setStatus('success');
    } catch {
      clearCart();
      setStatus('success');
    }
  };

  return (
    <div className="substack-site">
      <Header navItems={NAV_ITEMS} />

      <main style={{ maxWidth: '600px', margin: '80px auto', padding: '20px', textAlign: 'center' }}>
        {status === 'loading' ? (
          <div className="loading-spinner" />
        ) : (
          <>
            <div style={{ fontSize: '64px', marginBottom: '24px' }}>🎉</div>
            <h1 style={{
              fontFamily: "'Playfair Display', Georgia, serif",
              fontSize: '36px', marginBottom: '16px', color: '#1a1a1a'
            }}>
              Thank you for your order!
            </h1>
            <p style={{ fontSize: '18px', color: '#666', marginBottom: '32px', lineHeight: '1.6' }}>
              Your order has been received and is being processed. You'll receive a confirmation email shortly.
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link
                to="/gallery"
                style={{
                  display: 'inline-block', padding: '14px 28px',
                  background: '#1a1a1a', color: '#fff',
                  borderRadius: '6px', textDecoration: 'none',
                  fontSize: '15px', fontWeight: '500'
                }}
              >
                Continue Shopping
              </Link>
              <Link
                to="/"
                style={{
                  display: 'inline-block', padding: '14px 28px',
                  border: '1px solid #ccc', borderRadius: '6px',
                  textDecoration: 'none', fontSize: '15px', color: '#333'
                }}
              >
                Go Home
              </Link>
            </div>
          </>
        )}
      </main>

      <Footer links={FOOTER_LINKS} />
    </div>
  );
}

export default CartSuccess;
